<template lang="pug">
  v-container#location(fluid)
    .form-title.main-text.ligth Ubicación en el mapa de último avistamiento
    h2.form-subtitle Elige uno de los lugares previamente registrados, si no aparece agrega uno nuevo introduciendo la dirección y arrastrando el pin.

    v-row(d-flex justify="space-between")
      v-col.py-0(xs=12 sm=12)
        v-form.d-flex.justify-space-between
          v-col.py-0(xs=5 sm=5)
            v-text-field(
              v-model="lastSeenPlace"
              label="Nombre del punto"
              data-vv-name="name"
              :value="lastSeenLocationName"
            )
          v-col.py-0(xs=5 sm=5)
            .input-group.input-group--text-field.primary--text
              vue-google-autocomplete(
                ref="address"
                id="map"
                classname="form-control"
                :placeholder="direccion"
                v-on:placechanged="getAddressData"
                types="geocode"
                country="mx"
              )
            .input-group__details.location

    v-row
      v-col(d-flex)
        #mymap

    br
    br
    h1.form-title2.accent-text Seguimiento
    v-row.pt-6
      v-col.pa-0.mr-4(xs=5 sm=5 fluid)
        v-row
          label.custom.mb-2  Estatus de la víctima
        v-row
          v-col.align-radios.pa-0(d-flex xs=12 sm=12)
            v-radio-group(v-model="victimStatus" row hide-details @change="clearDetails($event,'victimStatus')")
              v-radio(
              	v-for="(victimStatusOpt, i) in locationStatusOpts"
              	:key="`victimStatusOpt${i}`"
              	:value="i"
              	:label="victimStatusOpt.name"
              )
      v-col(xs-12)
        v-row
          v-col.py-0(xs=10 sm=6 v-if="victimStatus == 0")
            v-menu(
              v-model="locationDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            )
              template(
                v-slot:activator="{ on }"
              )
                v-text-field(
                  ref="victim-status"
                  :disabled = "victimStatus == 2 || victimStatus == -1"
                  :value="formatDate(locationDate)"
                  label="Fecha de ubicación"
                  v-on="on"
                  readonly
                )
              v-date-picker(v-model="locationDate" @input="locationDateMenu = false" color="grey lighten-2")
          v-col.py-0(xs=10 sm=6 v-if="victimStatus == 1")
            v-menu(
              v-model="bodyLocationDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            )
              template(
                v-slot:activator="{ on }"
              )
                v-text-field(
                  ref="victim-status"
                  :disabled = "victimStatus == 2 || victimStatus == -1"
                  :value="formatDate(bodyLocationDate)"
                  label="Fecha de localización de restos"
                  v-on="on"
                  readonly
                )
              v-date-picker(v-model="bodyLocationDate" @input="bodyLocationDateMenu = false" color="grey lighten-2")
          v-col.py-0(xs=10 sm=6 v-if="victimStatus == 1")
            v-menu(
              v-model="locationNotificationDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            )
              template(
                v-slot:activator="{ on }"
              )
                v-text-field(
                  ref="victim-status"
                  :disabled = "victimStatus == 2 || victimStatus == -1"
                  :value="formatDate(locationNotificationDate)"
                  label="Fecha de notificación"
                  v-on="on"
                  readonly
                )
              v-date-picker(v-model="locationNotificationDate" @input="locationNotificationDateMenu = false" color="grey lighten-2")

    v-row.py-1.mt-3.checkboxes.actions(align="end" justify="space-between")
      v-col.pa-0(xs=6 sm=6)
        v-row(align="center")
          label.custom.mb-2 ¿Se acordaron acciones desde el CEDEHM?
          v-col.align-radios.pr-0(d-flex xs=4 sm=3)
            v-radio-group(v-model="cedehmActions" row hide-details @change="clearDetails($event,'cedehmActions')")
              v-radio(
              	v-for="(cedehmActionsOpt, i) in directAnswers"
              	:key="`cedehmActionsOpt${i}`"
              	:value="i"
              	:label="cedehmActionsOpt.name"
              )

    v-row.pb-1(align="center" justify="space-between")
      v-col.pa-0(d-flex xs=6 sm=6)
        .d-flex.tracing(v-for="(action, index) in tracingActions")
          v-text-field(
            :disabled = "!!cedehmActions"
            v-model="tracingActions[index]"
            label="Acción"
          )
          v-icon.delete-action(@click="delectTracingAction(index)") clear
      v-col.add-button.pl-5(d-flex xs=6 sm=6 v-if="!cedehmActions")
        v-row.add-button
          v-btn(outlined fab color="#4a4a4a" @click="addTracingAction" :disabled="!!cedehmActions")
            v-icon add
          p.ml-2 Agregar acción


    br
    // if victimStatus localizada con o sin vida
    div(v-if="victimStatus == 0 || victimStatus == 1")
      .form-title.main-text.ligth Ubicación en el mapa de la localización de la víctima
      h2.form-subtitle Elige uno de los lugares previamente registrados, si no aparece agrega uno nuevo introduciendo la dirección y arrastrando el pin.

      v-row(d-flex justify="space-between")
        v-col.py-0(xs=12 sm=12)
          v-form.d-flex.justify-space-between
            v-col.py-0(xs=5 sm=5)
              v-text-field(
                v-model="victimPlace"
                label="Nombre del punto"
                data-vv-name="name"
                :value="victimLocationName"
              )
            v-col.py-0(xs=5 sm=5)
              .input-group.input-group--text-field.primary--text
                vue-google-autocomplete(
                  ref="victimaddress"
                  id="victimmap"
                  classname="form-control"
                  :placeholder="victimAdress ? victimAdress : 'Dirección en el mapa'"
                  v-on:placechanged="getAddressData"
                  types="geocode"
                  country="mx"
                )
              .input-group__details.location
      v-row
        v-col(d-flex)
          #victimsmap

</template>
<script>
import * as L from "leaflet";
import * as _ from "lodash";
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  name: "Location",
  components: { VueGoogleAutocomplete },
  props: {},
  data() {
    return {
      tileLayer: undefined,
      accessToken: undefined,
      mapOptions: undefined,
      lastSeenLocationName: "",
      victimLocationName: "",
      locationAddress: "",
      victimLocationAddress: "",
      mymap: undefined,
      victimsMap: undefined,
      markers: [],
      locationDateMenu: false,
      bodyLocationDateMenu: false,
      locationNotificationDateMenu: false,
      locationStatusOpts: [
        { name: "Localizado con vida", slug: "alive" },
        { name: "Localizado sin vida", slug: "deceased" },
        { name: "Sin localizar", slug: "unknown" }
      ]
    };
  },
  computed: {
    record() {
      return this.$store.getters.record;
    },
    directAnswers() {
      return this.$store.state.directAnswers;
    },
    lastSeenPlace: {
      get() {
        return this.$store.state.record.narrative.lastSeenLocation.place;
      },
      set(value) {
        this.$store.state.record.narrative.lastSeenLocation.place = value;
      }
    },
    victimPlace: {
      get() {
        return this.$store.state.record.narrative.victimLocation.place;
      },
      set(value) {
        this.$store.state.record.narrative.victimLocation.place = value;
      }
    },
    direccion() {
      return (
        this.$store.state.record.narrative.lastSeenLocation.address ||
        "Dirección en el mapa"
      );
    },
    address: {
      get() {
        return this.$store.state.record.narrative.lastSeenLocation.address;
      },
      set(value) {
        this.$store.state.record.narrative.lastSeenLocation.address = value;
      }
    },
    victimAdress: {
      get() {
        return this.$store.state.record.narrative.victimLocation.address;
      },
      set(value) {
        this.$store.state.record.narrative.victimLocation.address = value;
      }
    },
    /*lat: {
      get() {
        return this.$store.state.record.narrative.lastSeenLocation.lat;
      },
      set(value) {
        this.$store.state.record.narrative.lastSeenLocation.lat = value;
      }
    },
    lng: {
      get() {
        return this.$store.state.record.narrative.lastSeenLocation.lng;
      },
      set(value) {
        this.$store.state.record.narrative.lastSeenLocation.lng = value;
      }
    }*/
    victimStatus: {
      get() {
        var newVal = this.locationStatusOpts.findIndex(
          status =>
            status.slug ==
            this.$store.state.record.narrative.tracing.victimStatus.slug
        );
        if (newVal == 0 || newVal == 1) {
          // eslint-disable-next-line
          setTimeout(() => {
            //this.drawAdvisoryMap();
            this.drawVictimsMap();
          }, 100);
        }
        return this.locationStatusOpts.findIndex(
          status =>
            status.slug ==
            this.$store.state.record.narrative.tracing.victimStatus.slug
        );
      },
      set(index) {
        this.$store.state.record.narrative.tracing.victimStatus = this.locationStatusOpts[
          index
        ];
      }
    },
    locationDate: {
      get() {
        return this.$store.state.record.narrative.tracing.locationDate;
      },
      set(value) {
        this.$store.state.record.narrative.tracing.locationDate = value;
      }
    },
    bodyLocationDate: {
      get() {
        return this.$store.state.record.narrative.tracing.bodyLocationDate;
      },
      set(value) {
        this.$store.state.record.narrative.tracing.bodyLocationDate = value;
      }
    },
    locationNotificationDate: {
      get() {
        return this.$store.state.record.narrative.tracing
          .locationNotificationDate;
      },
      set(value) {
        this.$store.state.record.narrative.tracing.locationNotificationDate = value;
      }
    },
    cedehmActions: {
      get() {
        return this.directAnswers.findIndex(
          directAnswer =>
            directAnswer.slug ==
            this.$store.state.record.narrative.tracing.cedehmActions.slug
        );
      },
      set(index) {
        this.$store.state.record.narrative.tracing.cedehmActions = this.directAnswers[
          index
        ];
      }
    },
    tracingActions: {
      get() {
        return this.$store.state.record.narrative.tracing.actions;
      },
      set(value) {
        this.$store.state.record.narrative.tracing.actions = value;
      }
    }
  },
  methods: {
    clearDetails(value, reference) {
      if (reference === "cedehmActions") {
        if (value == 1) {
          this.tracingActions = [""];
        }
      } else {
        if (value == 0) {
          this.locationNotificationDate = null;
          this.bodyLocationDate = null;
        } else if (value == 1) {
          this.locationDate = null;
        } else if (value == 2) {
          this.locationDate = null;
          this.locationNotificationDate = null;
          this.bodyLocationDate = null;
        }
      }
    },
    addTracingAction() {
      this.tracingActions = this.tracingActions.concat([""]);
    },
    delectTracingAction(index) {
      if (this.tracingActions.length > 1) this.tracingActions.splice(index, 1);
      else if (this.tracingActions.length == 1) this.tracingActions = [""];
    },
    drawAdvisoryMap() {
      this.mymap = L.map("mymap").setView([23.6345, -102.5528], 5);
      this.mymap.scrollWheelZoom.disable();

      L.tileLayer(
        `${this.tileLayer}?access_token=${this.accessToken}`,
        this.mapOptions
      ).addTo(this.mymap);

      if (this.$store.state.editing) {
        this.createMarker(
          {
            lat: this.record.narrative.lastSeenLocation.lat,
            long: this.record.narrative.lastSeenLocation.lng
          },
          this.mymap,
          "map"
        );
      }
    },
    drawVictimsMap() {
      this.victimsMap = L.map("victimsmap").setView([23.6345, -102.5528], 5);
      this.victimsMap.scrollWheelZoom.disable();

      L.tileLayer(
        `${this.tileLayer}?access_token=${this.accessToken}`,
        this.mapOptions
      ).addTo(this.victimsMap);

      this.victimsMap.invalidateSize();

      if (this.$store.state.editing) {
        this.createMarker(
          {
            lat: this.record.narrative.victimLocation.lat,
            long: this.record.narrative.victimLocation.lng
          },
          this.victimsMap,
          "victimsmap"
        );
      }
    },
    getAddressData(addressData, placeResultData, id) {
      if (id === "map") {
        this.record.narrative.lastSeenLocation.lat = addressData.latitude.toString();
        this.record.narrative.lastSeenLocation.lng = addressData.longitude.toString();
        this.record.narrative.lastSeenLocation.address =
          placeResultData.formatted_address;

        this.lastSeenLocationName = placeResultData.formatted_address;
        this.locationAddress = {
          lat: addressData.latitude,
          long: addressData.longitude
        };

        this.mymap.setView(
          [this.locationAddress.lat, this.locationAddress.long],
          17
        );

        this.createMarker(this.locationAddress, this.mymap, id);
      } else {
        this.record.narrative.victimLocation.lat = addressData.latitude.toString();
        this.record.narrative.victimLocation.lng = addressData.longitude.toString();
        this.record.narrative.victimLocation.address =
          placeResultData.formatted_address;

        this.victimLocationName = placeResultData.formatted_address;
        this.victimLocationAddress = {
          lat: addressData.latitude,
          long: addressData.longitude
        };
        this.victimsMap.setView(
          [this.victimLocationAddress.lat, this.victimLocationAddress.long],
          17
        );

        this.createMarker(this.victimLocationAddress, this.victimsMap, id);
      }
    },
    createMarker(address, map, id) {
      const markerExists = _.find(this.markers, m => {
        return m.id === id;
      });

      if (markerExists) {
        map.removeLayer(markerExists.marker);
      }

      const svg = `
        <?xml version="1.0" encoding="UTF-8"?>
        <svg width="30px" height="37px" viewBox="0 0 30 37" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
            <title>Shape</title>
            <desc>Created with Sketch.</desc>
            <defs>
                <path d="M738,1112 C731.918571,1112 727,1116.5385 727,1122.15 C727,1129.7625 738,1141 738,1141 C738,1141 749,1129.7625 749,1122.15 C749,1116.5385 744.081429,1112 738,1112 L738,1112 Z M734,1122 C734,1119.792 735.7248,1118 737.85,1118 C739.9752,1118 741.7,1119.792 741.7,1122 C741.7,1124.208 739.9752,1126 737.85,1126 C735.7248,1126 734,1124.208 734,1122 Z" id="path-1"></path>
                <filter x="-31.8%" y="-17.2%" width="163.6%" height="148.3%" filterUnits="objectBoundingBox" id="filter-2">
                    <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                    <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                    <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.258520154 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
                </filter>
            </defs>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="RRM_back02" transform="translate(-723.000000, -1110.000000)">
                    <g id="Shape">
                        <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use>
                        <use fill="${
                          id === "map" ? "#ae0074" : "#006500"
                        }" fill-rule="evenodd" xlink:href="#path-1"></use>
                    </g>
                </g>
            </g>
        </svg>
      `;

      const mapIcon = L.divIcon({
        className: "pin",
        html: svg,
        iconAnchor: [16, 34],
        popupAnchor: [0, -35]
      });

      let marker = new L.marker([address.lat, address.long], {
        draggable: true,
        icon: mapIcon
      });

      this.markers.push({ id: id, marker: marker });

      if (marker) {
        marker.on("move", e => {
          address = e.latlng;
        });
        marker.on("dragend", () => {
          this.geocode(address, id);
        });
      }
      marker.addTo(map);
    },
    geocode(latlng, id) {
      var that = this;
      // eslint-disable-next-line
      let geocoder = new google.maps.Geocoder();
      geocoder.geocode({ location: latlng }, function(results, status) {
        if (status === "OK") {
          if (results[0] && id === "map") {
            this.locationAddress = latlng;
            this.lastSeenLocationName = results[0].formatted_address;

            that.$refs.address.$el.value = this.lastSeenLocationName;
            that.record.narrative.lastSeenLocation.address = this.lastSeenLocationName;
            that.record.narrative.lastSeenLocation.lat = latlng.lat.toString();
            that.record.narrative.lastSeenLocation.lng = latlng.lng.toString();
          } else if (results[0]) {
            this.victimLocationAddress = latlng;
            this.victimLocationName = results[0].formatted_address;

            that.$refs.victimaddress.$el.value = this.victimLocationName;
            that.record.narrative.victimLocation.address = this.victimLocationName;
            that.record.narrative.victimLocation.lat = latlng.lat.toString();
            that.record.narrative.victimLocation.lng = latlng.lng.toString();
          } else {
            window.alert("No se encontraron resultados");
          }
        } else {
          console.log("Geocoder failed due to: " + status);
        }
      });
    },
    formatDate(value) {
      return value
        ? new Intl.DateTimeFormat("es").format(new Date(`${value}T00:00`))
        : "";
    }
  },
  mounted() {
    delete L.Icon.Default.prototype._getIconUrl;

    L.Icon.Default.mergeOptions({
      iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
      iconUrl: require("leaflet/dist/images/marker-icon.png"),
      shadowUrl: require("leaflet/dist/images/marker-shadow.png")
    });

    let iconUrl = "https://www.iconsdb.com/icons/preview/red/circle-xxl.png";
    L.icon({
      iconRetinaUrl: iconUrl,
      iconUrl: iconUrl,
      iconSize: 10
    });

    this.tileLayer = "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}";
    this.accessToken =
      "pk.eyJ1Ijoiam9yYW5kcmFkZWZpZyIsImEiOiJjamV0bm9vczAzMTc3MnlvMG4wMTBlaXY0In0.6Te0HBRHyNH0TAVIQNT89w";

    this.mapOptions = {
      attribution:
        'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
      maxZoom: 18,
      tileSize: 512,
      zoomOffset: -1,
      id: "mapbox/streets-v11"
    };

    setTimeout(() => {
      this.drawAdvisoryMap();
      this.drawVictimsMap();
    }, 100);
  }
};
</script>

<style scoped lang="scss">
.form-subtitle {
  color: $font-map-color !important;
  font-size: 14px !important;
}

.v-form {
  align-items: baseline;
}

.input-group__details.location {
  color: inherit;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding-top: 4px;
  -webkit-box-flex: 1;
  -ms-flex: 1 0 100%;
  flex: 1 0 100%;
  font-size: 12px;
  min-height: 26px;
  overflow: hidden;
  position: relative;
  width: 100%;
  &:before {
    background-color: rgba(0, 0, 0, 0.42);
    top: 0;
    height: 1px;
    width: 100%;
    z-index: 0;
  }
  &:after {
    background-color: rgb(43, 72, 148);
    color: inherit;
    top: 0;
    height: 2px;
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transform-origin: center center 0;
    transform-origin: center center 0;
    width: 100%;
    z-index: 1;
  }
  &:before,
  &:after {
    content: "";
    position: absolute;
    left: 0;
    -webkit-transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
}
.form-control {
  width: 100% !important;
  text-overflow: ellipsis;
}

.map-title {
  color: #030303;
  font-size: 16px;
  font-weight: bold;
}

#mymap {
  width: 100%;
  height: 500px;
}

#victimsmap {
  width: 100%;
  height: 500px;
}

#location .actions .checkbox {
  margin-left: 50px;
}

.v-text-field {
  margin-top: 0px !important;
}

.align-radios {
  align-self: flex-end;
}

.actions label.custom {
  font-size: 12px !important;
}

.tracing {
  .delete-action {
    opacity: 0;
  }
  &:hover {
    .delete-action {
      opacity: 1;
      cursor: pointer;
    }
  }
}
</style>
